import axios from 'axios'
import React, { useState } from 'react'
import useSWR from 'swr'

import { swalError, swalSuccess } from '../../../common/components/Swaler'

const Drivers = () => {
 const [search, setSearch] = useState('')
 const [driver, setDriver] = useState(null)

 const { data: list } = useSWR(search.length > 2 && `/subject/admin/drivers?search=${search}`)

 const updateDriver = async ({ _id, password }) => {
  if (!password || password.length < 8) return swalError('Lösenordet måste ha minst 8 tecken')

  axios.put(`/subject/admin/drivers/${_id}`, { password }).then(() => swalSuccess('Uppdaterat', '',  'OK')).catch((e) => {
    swalError('Fel', e.message)
  })
 }

 const deleteDriver = async ({ _id }) => {
  axios.delete(`/subject/admin/drivers/${_id}`).then(() =>{ 
  swalSuccess('Raderat', '',  'OK') 
  setSearch('')
  setDriver(null)
}).catch((e) => {
    swalError('Fel', e.message)
  })
 }

 return (
  <div>
   <br />
   <input
    type="text"
    placeholder="Sök efter telefonnummer"
    value={search}
    onChange={(e) => {
     if (driver) setDriver(null)
     setSearch(e.target.value)
    }}
     />
    <div className="flex" style={{ justifyContent: 'start' }}>
      {list?.map((d) => (
        <div key={d._id} style={{ background: '#fff', cursor: 'pointer' }} onClick={() => setDriver(d)}>
        {`${d.name} ${d.surname || ''}, ${d.phone} (${d.carrier.organization})`}
        </div>
      ))}
    </div>
   {driver && (
    <div>
     <p>{`Ändra ${driver.name || 'Okänd'}s (${driver.carrier.organization}) uppgifter`}</p>
     <div>
       <span>
         <input type="password" value={driver.password || ''} onChange={(e) => setDriver({ ...driver, password: e.target.value })} placeholder="Lösenord" />
         <button onClick={() => updateDriver(driver)}>Uppdatera</button>
         <button onClick={() => deleteDriver(driver)} style={{background: 'red'}}>Radera</button>
       </span>
     </div>
    </div>
   )}
  </div>
 )
}

export default Drivers
